import useReveal from '../../hooks/useReveal';

const PageRefinedHero = ({ badge, title, titleAccent, subtitle, benefits = [] }) => {
  const [heroRef, heroVisible] = useReveal();
  const [benefitsRef, benefitsVisible] = useReveal();

  return (
    <>
      <div ref={heroRef} className="list-page-hero list-page-hero--refined">
        <div className="hero-ambient-orb hero-ambient-orb--1 list-page-hero__orb" aria-hidden="true"></div>
        <div className="hero-ambient-orb hero-ambient-orb--2 list-page-hero__orb" aria-hidden="true"></div>
        <div className="hero-ambient-orb hero-ambient-orb--3 list-page-hero__orb" aria-hidden="true"></div>

        <div className="list-page-hero__inner">
          <div className={`reveal-up ${heroVisible ? 'visible' : ''}`}>
            <div className="hero-badge list-page-hero__badge">
              <span className="hero-badge-dot" aria-hidden="true" />
              <span className="hero-badge-text">{badge}</span>
            </div>
          </div>
          <h1 className={`reveal-up delay-1 ${heroVisible ? 'visible' : ''}`}>
            {title}
            {titleAccent ? <> <em>{titleAccent}</em></> : null}
          </h1>
          <p className={`reveal-up delay-2 ${heroVisible ? 'visible' : ''}`}>{subtitle}</p>
        </div>
      </div>

      {benefits.length > 0 && (
        <div
          ref={benefitsRef}
          className={`list-benefits-row${benefitsVisible ? ' list-benefits-row--visible' : ''}`}
        >
          <div className="list-benefits-line" aria-hidden="true">
            <div className={`list-benefits-line-draw${benefitsVisible ? ' visible' : ''}`} />
          </div>
          {benefits.map((benefit, i) => (
            <div
              key={benefit.title}
              className={`list-benefit-card reveal-up${benefitsVisible ? ' visible' : ''}`}
              style={{ transitionDelay: `${0.35 + i * 0.1}s` }}
            >
              <i className={benefit.icon} aria-hidden="true" />
              <div className="list-benefit-card__copy">
                <strong>{benefit.title}</strong>
                <span>{benefit.subtitle}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default PageRefinedHero;
